/** @jsx jsx */
import React, { useState, useMemo, useCallback } from 'react';
import { jsx, css } from '@emotion/react';
import TmReactTable from '../../utilComponents/tmReactTable/tmReactTable';
import TmExportExcel from '../../utilComponents/tmExportExcel/tmExportExcel';
import StatusFilter from './StatusFilter';
import { callStatus } from '../../../util/constants';
import moment from 'moment';

const TRUCK_STATUS_COLORS = {
    available: '#28a745', unavailable: '#dc3545', assigned: '#007bff', enroute: '#fd7e14'
};

const truckBadge = (status) => css`
    display: inline-block; padding: 2px 10px; font-size: 0.72rem;
    font-weight: 600; border-radius: 3px; color: #fff; letter-spacing: 0.3px;
    background: ${TRUCK_STATUS_COLORS[(status || '').toLowerCase()] || '#6c757d'};
`;

const sectionStyle = css`
    margin-top: 20px; padding-top: 16px; border-top: 1px solid #e9ecef;
`;

const TruckVisibility = ({ data = [], onForceLogout, canLogout }) => {
    const [byStatus, setByStatus] = useState(callStatus);

    const filteredData = useMemo(() => {
        const sel = Object.entries(byStatus).filter(([, v]) => v.selected).map(([k]) => k.toLowerCase());
        if (sel.length === 0) return data;
        return data.filter(item => sel.includes((item.truckStatus || '').toLowerCase()));
    }, [data, byStatus]);

    const exportData = useMemo(() => [{
        columns: [{ title: 'Truck' }, { title: 'Driver' }, { title: 'Status' }],
        data: data.map(item => [
            { value: item.truckId || '' }, { value: item.userId || '' }, { value: item.truckStatus || '' }
        ])
    }], [data]);

    const columns = useMemo(() => [
        { Header: 'Truck', accessor: 'truckId', style: { textAlign: 'center' } },
        { Header: 'Driver', accessor: 'userId', style: { textAlign: 'center' } },
        {
            Header: 'Status', accessor: 'truckStatus', style: { textAlign: 'center' },
            Cell: row => <span css={truckBadge(row.value)}>{row.value}</span>
        },
        {
            Header: 'Actions', id: 'actions', filterable: false,
            style: { textAlign: 'center' }, width: 130,
            Cell: row => canLogout ? (
                <button className="btn btn-sm btn-outline-danger"
                    onClick={() => onForceLogout(row.original.driverId, row.original.truckId)}>
                    Force Logout
                </button>
            ) : null
        }
    ], [canLogout, onForceLogout]);

    return (
        <div css={sectionStyle}>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 className="mb-0 font-weight-bold text-dark">
                    <i className="fa fa-truck mr-1 text-primary"></i> Driver Availability
                </h5>
                <TmExportExcel name="Truck Visibility"
                    filename={`Truck_Visibility_${moment().format('MMDDYYhhmm')}`}
                    fileExtension="xlsx"
                    element={<button className="btn btn-sm btn-outline-success"><i className="fa fa-file-excel-o"></i></button>}
                    dataSet={exportData} />
            </div>
            <div className="mb-2">
                <StatusFilter id="vehicle" byType="vehicle" label="By Status:" options={byStatus}
                    exclude={['Requested']} onChange={setByStatus} />
            </div>
            <TmReactTable filterable sortable resizable defaultPageSize={10} data={filteredData} columns={columns} />
        </div>
    );
};

export default React.memo(TruckVisibility);
